import React from 'react';
import Box from '../box';
import { cdnUrl, vui } from '../core';
import Svg from '../svg';
import { cs } from '../utils';
const veracityLogo = `${cdnUrl}/common/icons/logos/veracity-logo.svg`;
const dnvLogo = `${cdnUrl}/common/icons/logos/dnv-logo.svg`;
/** Brand logo. */
export const Logo = vui((props, ref) => {
    const { brand, children, className, src, styles, url, ...rest } = props;
    let svgSrc = src;
    if (!svgSrc)
        svgSrc = brand === 'dnv' ? dnvLogo : veracityLogo;
    const linkProps = url ? { as: 'a', href: url, outline: 'none', focusRing: 2 } : {};
    return (React.createElement(Box, { centerV: true, className: cs('vui-logo', className), flexShrink: 0, h: 40, mr: 2, ref: ref, ...styles?.container, ...linkProps, ...rest }, children ?? React.createElement(Svg, { "aria-label": "logo", h: "100%", src: svgSrc, ...styles?.svg })));
});
export default Logo;
